import { render, staticRenderFns } from "./BookingsTable.vue?vue&type=template&id=25af7004&"
import script from "./BookingsTable.vue?vue&type=script&lang=js&"
export * from "./BookingsTable.vue?vue&type=script&lang=js&"
import style0 from "./BookingsTable.vue?vue&type=style&index=0&id=25af7004&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports